import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import {
  PRODUCT_RECOMMENDATIONS_FEATURE,
  ProductRecommendationsState,
  StateWithProductRecommendations,
} from '../product-recommendations-state';

export const getFeatureState: MemoizedSelector<StateWithProductRecommendations, ProductRecommendationsState> =
  createFeatureSelector<ProductRecommendationsState>(PRODUCT_RECOMMENDATIONS_FEATURE);
